import React from 'react';
import './terms.css';
import SEO from './SEO';

const TermsConditions = () => {
    return (
        <div className="terms-container">
            <SEO
                title="Terms & Conditions"
                description="Read our terms and conditions to understand the rules and guidelines for using Edraak's services. Ensure a smooth experience by familiarizing yourself with our policies."
                image=""
                url="https://edraakonline.com/terms-and-conditions"
            />
            <header className="terms-header">
                <h1>TERMS & CONDITION</h1>
            </header>

            <section>
                <h2>1. ACCEPTANCE OF TERMS</h2>
                <p>
                    We offer our service to you, subject to the following Terms of Service. These policies may
                    be updated by us from time to time without any notice for the wellness of our service and
                    you. You can always read and check our terms and policies on this page. For registered
                    user they will get a notification regarding the update of terms and conditions.
                </p>

                <h2>2. USAGE</h2>
                <p>
                    Edraak learn compete caters and shares aptitude and MCQ related questions with best possible answers. The questions are based on the type of questions that are asked in various aptitudes related exams. These all data are collected and shared by various users so there might be some repetition. We do not guarantee reoccurrence of the questions. Edraak learn compete  also does not guarantee 100% correctness of questions and their answers. Though, Edraak learn compete  has taken all possible steps to make all data 100% correct. The sole purpose of Edraak learn compete is to provide information to public.  We assume no liability for disputes regarding ownership, copyright, or trademarks of the data submitted to this site. Examveda reserves the right to refuse to post any submission, to alter submissions, and to remove a submission from the site. Edraak learn compete  works for the wellness of contents and users so it can also remove or add data without any individual notice. All trademarks and company names published in this site are subjected to their respected owners and companies.
                </p>
                <p>
                    We respect our users and love their inputs as comment or question submission or in any other mean. However; we find the you are abusing or posting foul or unwanted content, then in this case we have right to terminate your account.


                </p>

                <h2>3. REGISTRATION INTO SITE</h2>
                <p>
                    Edraak learn compete has registration services on the site which is optional. A registered
                    user can enjoy all its service and can submit and download the things that are shared by
                    the system or other users.
                </p>

                <h2>5. COPYRIGHT POLICY</h2>
                <p>
                    All pages, data and graphics presented on this website are the property of examveda.com. The pages may not be redistributed or reproduced in any way, shape, or form without the written permission of examveda.com respects the copyrights, trademarks and intellectual property of others and also we expect this from other users. In this site, if you find any information that is owned by you or any content that violates your intellectual property rights, please contact to us with all necessary documents/information that authenticate your authority on your property.
                </p>

                <h2>6. COOKIES</h2>
                <p>
                    We employ the use of cookies. By accessing MCQ Questions, you agreed to use cookies in agreement with the MCQ Questions’s Privacy Policy.
                </p>

                <p>
                    Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.
                </p>

                <h2>7. COPYRIGHT</h2>

                <p>
                    All materials – including but not limited to text, photographs, video, audio, images and any other content – appearing via the Online Course and/or on the Website are protected by copyrights and/or other proprietary rights belonging to The EDRAAK and/or other third parties. You agree to abide by all applicable laws regarding copyrights, trademarks, publicity rights and privacy rights in INDIA
                </p>

                <p>
                    You may not copy, reproduce, duplicate, distribute, disseminate, publish, post, display, perform, modify, create derivative works from, upload to, transmit, or in any way exploit any content from the Online Course and/or on the Website.  You may not sell or offer for sale any of the content, or allow third parties to access it, or use such content to construct any kind of database. You may use the content from the Online Course and/or on the Website only for personal, non-commercial use.
                </p>

                <p>
                    You agree to maintain the security of any user name and password required for accessing the Online Course. You will notify us promptly if you become aware of any unauthorized use of your username and/or password. Only you may access the course using your login details.


                </p>

                <h2>6. DATA PROTECTION</h2>
                <p>
                    By registering with EDRAAK Hub and by paying the fees, you agree to The EDRAAK collecting and using your personal data. This will be done in accordance with The EDRAAK’s privacy policy.
                </p>
            </section>
        </div>
    );
};

export default TermsConditions;
